(function () {
  'use strict';
  if (window.wwhTaxExemptionInitialized) return;
  window.wwhTaxExemptionInitialized = true;
  var observers = new Map();
  var clearButtons = new WeakSet();

  function initializeForms() {
    document.querySelectorAll('.wwh-tax-page [data-wwh-tax-form]').forEach(function (container) {
      if (observers.has(container)) return;
      function enhanceForm() {
        container.querySelectorAll('.globo-form-control[data-type="file2"]').forEach(function (control) {
          var input = control.querySelector('input[data-allowed-extensions]');
          var caption = control.querySelector('.gfb__dropzone--placeholder--description');
          if (!input || !caption || caption.dataset.wwhTaxFormats) return;
          var formats = input.dataset.allowedExtensions.split(',').map(function (value) {
            return value.trim().toUpperCase();
          }).filter(Boolean);
          if (!formats.length) return;
          caption.dataset.wwhTaxFormats = 'true';
          caption.textContent = container.dataset.formatsLabel + ' ' + formats.join(', ') + '.';
        });
        container.querySelectorAll('#paragraph-1 p').forEach(function (paragraph) {
          if (!paragraph.textContent.trim()) paragraph.hidden = true;
        });
        container.querySelectorAll('.gfb__signature__clear').forEach(function (button) {
          if (clearButtons.has(button)) return;
          button.setAttribute('role', 'button');
          button.setAttribute('tabindex', '0');
          button.setAttribute('aria-label', container.dataset.clearLabel);
          button.addEventListener('keydown', function (event) {
            if (event.key !== 'Enter' && event.key !== ' ') return;
            event.preventDefault();
            button.click();
          });
          clearButtons.add(button);
        });
      }
      var observer = new MutationObserver(enhanceForm);
      observer.observe(container, { childList: true, subtree: true });
      observers.set(container, observer);
      enhanceForm();
    });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('.wwh-tax-page [data-wwh-tax-chat]');
    if (!trigger) return;
    var status = trigger.closest('.wwh-tax__support').querySelector('[data-wwh-tax-chat-status]');
    if (window.Formilla && typeof window.Formilla.initFormillaChat === 'function') {
      status.hidden = true;
      window.Formilla.initFormillaChat();
    } else {
      status.hidden = false;
    }
  });
  document.addEventListener('shopify:section:unload', function (event) {
    observers.forEach(function (observer, container) {
      if (!event.target.contains(container)) return;
      observer.disconnect();
      observers.delete(container);
    });
  });
  document.addEventListener('shopify:section:load', initializeForms);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeForms);
  else initializeForms();
})();
